import { render, staticRenderFns } from "./EditPasswordDialog.vue?vue&type=template&id=28ec5e99&scoped=true&"
import script from "./EditPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./EditPasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditPasswordDialog.vue?vue&type=style&index=0&id=28ec5e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec5e99",
  null
  
)

component.options.__file = "EditPasswordDialog.vue"
export default component.exports